import { ProgressBarFill } from './progress-bar-fill';
import { ProgressBarSections } from './progress-bar-sections';
import { ProgressBarProps, ProgressBarSize } from './progress-bar.type';
import { parseColor } from './utils';
import { Tooltip } from '../../';

const progressBarSize: { [key in ProgressBarSize]: string } = {
  small: 'h-2',
  medium: 'h-4',
  large: 'h-9',
};

export const ProgressBar = (props: ProgressBarProps) => {
  const { size = 'small', progress, sections, label, color, total = 100, remainingLabel, containerClassName } = props;

  const parsedColor = color ? parseColor(color) : 'bg-blue-500';

  return (
    <div
      className={`
      flex w-full flex-1 overflow-hidden rounded-full bg-gray-300
      ${progressBarSize[size]}
      ${containerClassName ?? containerClassName}	
      `}
    >
      {progress ? (
        <ProgressBarFill progress={progress} label={label} color={parsedColor} total={total} />
      ) : (
        <ProgressBarSections sections={sections} total={total} />
      )}
      {remainingLabel && (
        <div className="flex h-full flex-1">
          <Tooltip
            title={remainingLabel}
            containerClassName="flex-1"
            placement="bottom"
            offsetOptions={10}
            arrowPointAtCenter
            autoPlacementOptions={{ autoAlignment: true, allowedPlacements: ['bottom', 'bottom-end', 'bottom-start'] }}
          >
            <div className="size-full"></div>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
